import { Activite } from './Activite.model';
export class ActivitesParUO {
  constructor(public allActivites: Activite[],
    public dateDebut: Date,
    public idUniteOrganisationnelle: Date,
    public dateFin?: Date,
  ) { }
} 